import { render } from "./RankingKeywords.vue?vue&type=template&id=1c6a46d2&scoped=true"
import script from "./RankingKeywords.vue?vue&type=script&lang=js"
export * from "./RankingKeywords.vue?vue&type=script&lang=js"

import "./RankingKeywords.vue?vue&type=style&index=0&id=1c6a46d2&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6a46d2"]])

export default __exports__